import { Button } from "@/components/ui/button";
import { useSendChatMessage } from "@/lib/hooks/useSendChatMessage";
import { RefreshCw } from "lucide-react";

interface RetryButtonProps {
  originalMessage: string;
}

export function RetryButton({ originalMessage }: RetryButtonProps) {
  const sendMessage = useSendChatMessage();

  const handleRetry = () => {
    sendMessage(originalMessage);
  };

  return (
    <Button variant="ghost" size="sm" onClick={handleRetry} className="mt-2">
      <RefreshCw className="h-4 w-4" />
      Retry
    </Button>
  );
}
